import CommentForm from "./CommentForm";

const Comment = ({
  comment,
  currentUser,
  deleteComment,
  updateComment,
  activeComment,
  setActiveComment,
  onDraftChange,
}) => {
  const fiveMinutes = 300000;
  const timePassed = new Date() - new Date(comment?.date) > fiveMinutes;
  const canEdit = comment?.user === currentUser && !timePassed;
  const canDelete = comment?.user === currentUser && !timePassed;
  const isEditing = activeComment && activeComment === comment?.id;

  // const deleteComment = (commentId) => {};

  return (
    <div className="comment">
      <div className="comment-right-part">
        <div className="comment-content">
          <div className="comment-date">
            {new Date(comment?.date).toLocaleString()}
          </div>
          <div className="comment-author">{comment?.user}:</div>
          <div className="comment-actions">
            {canEdit && (
              <div
                className="comment-action"
                onClick={() => setActiveComment(comment?.id)}
              >
                Edit
              </div>
            )}
            {canDelete && (
              <div
                className="comment-action"
                onClick={() => deleteComment(comment?.id)}
              >
                Delete
              </div>
            )}
          </div>
        </div>
        {!isEditing && <div className="comment-text">{comment?.comment}</div>}
        {isEditing && (
          <CommentForm
            submitLabel="Update"
            hasCancelButton
            initialText={comment?.comment}
            draftKey={`edit-${comment?.id}`}
            onDraftChange={onDraftChange}
            handleSubmit={(text) => updateComment(text, comment?.id)}
            handleCancel={() => setActiveComment(null)}
          />
        )}
      </div>
    </div>
  );
};

export default Comment;
